import React from 'react';
import { useTranslation } from 'react-i18next';
import { getStoreUrl } from '../utils/storeUrls';

// Mirrors the consumable IAPs in the app (credits_small / medium / large).
// Prices are the USD App Store tiers; the app shows local store pricing.
const PACKS = [
  { key: 'small', minutes: 10, price: '$0.49' },
  { key: 'medium', minutes: 35, price: '$1.99' },
  { key: 'large', minutes: 80, price: '$4.99' },
] as const;

const MinutePacks: React.FC = () => {
  const { t, i18n } = useTranslation();

  return (
    <div
      style={{
        marginTop: '48px',
        background: 'var(--v2-card)',
        border: '1px solid var(--v2-line)',
        borderRadius: '20px',
        padding: '32px 28px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '32px',
          alignItems: 'center',
        }}
      >
        {/* Copy */}
        <div>
          <span
            style={{
              display: 'inline-block',
              fontSize: '11px',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.07em',
              color: 'var(--v2-primary)',
              background: 'hsl(248 76% 59% / .1)',
              padding: '4px 12px',
              borderRadius: '999px',
              marginBottom: '14px',
            }}
          >
            {t('pricing.payg.badge', 'No subscription needed')}
          </span>
          <h3
            style={{
              fontSize: 'clamp(22px, 2.5vw, 28px)',
              fontWeight: 800,
              color: 'var(--v2-ink)',
              lineHeight: 1.2,
              marginBottom: '10px',
            }}
          >
            {t('pricing.payg.title', 'Or just pay per minute')}
          </h3>
          <p style={{ fontSize: '15px', color: 'var(--v2-ink-muted)', lineHeight: 1.6, marginBottom: '18px' }}>
            {t(
              'pricing.payg.subtitle',
              'Make a one-time purchase to add minutes on top of your daily limit. They never expire, and there is nothing to cancel.'
            )}
          </p>
          <a
            href={getStoreUrl(i18n.language)}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              padding: '11px 22px',
              borderRadius: '999px',
              fontWeight: 700,
              fontSize: '14px',
              textDecoration: 'none',
              background: 'var(--v2-primary)',
              color: '#fff',
            }}
          >
            {t('pricing.payg.cta', 'Buy minutes in the app')}
          </a>
        </div>

        {/* Packs */}
        <div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '12px',
            }}
          >
            {PACKS.map((pack) => (
              <div
                key={pack.key}
                style={{
                  background: 'var(--v2-bg-subtle)',
                  border: '1px solid var(--v2-line)',
                  borderRadius: '14px',
                  padding: '18px 8px',
                  textAlign: 'center',
                  minWidth: 0,
                }}
              >
                <div style={{ fontSize: '26px', fontWeight: 800, color: 'var(--v2-ink)', lineHeight: 1 }}>
                  {pack.minutes}
                </div>
                <div
                  style={{
                    fontSize: '12px',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    color: 'var(--v2-ink-muted)',
                    marginTop: '4px',
                    marginBottom: '12px',
                  }}
                >
                  {t('pricing.payg.minutes', 'minutes')}
                </div>
                <div style={{ fontSize: 'clamp(14px, 1.6vw, 17px)', fontWeight: 700, color: 'var(--v2-primary)', whiteSpace: 'nowrap' }}>
                  {t(`pricing.payg.packs.${pack.key}`, pack.price)}
                </div>
                <div style={{ fontSize: '11px', color: 'var(--v2-ink-muted)', marginTop: '2px' }}>
                  {t('pricing.payg.oneTime', 'one-time')}
                </div>
              </div>
            ))}
          </div>
          <p style={{ fontSize: '12px', color: 'var(--v2-ink-muted)', marginTop: '12px', textAlign: 'center' }}>
            {t(
              'pricing.payg.note',
              'Tap the minutes counter in the app to buy. Prices in USD; local store pricing may vary.'
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default MinutePacks;
